import React from "react";
import { VehicleRegisterTemplate } from "../../Templates/VehicleRegisterTemplate";

export const VehicleRegister = () => {
    return <VehicleRegisterTemplate />;
};